import { useMemo } from 'react';
import { ToothSurface } from '../../../../../graphql/graphql';
import { PATHOLOGY_ITEMS_SURFACES } from '../../../Components/DENTModalOverviewPathology/pathologyItemsSurfaces';
import { useDENTContext } from '../../../Services/DENTContext';
import useTooth from '../useTooth';
import { PathologyItem } from '../../../Enums/PathologyItem.enum';
import { SurfaceOperation } from '../../../Enums/SurfaceOperation.enum';
import { SurfaceHandler } from '../../../Interfaces/SurfaceHandler.interface';

export default function useDecaySurfaceHandler(
	decayIndex: number,
): SurfaceHandler {
	const { activeTooth } = useDENTContext();
	const {
		pathology: { decays },
	} = useTooth();

	const showedSurfaces = PATHOLOGY_ITEMS_SURFACES[PathologyItem.DECAY];

	const selectedSurfaces = useMemo(() => {
		return decays?.getSurfaces(decayIndex) ?? [];
	}, [decays, decayIndex, activeTooth]);

	const handleSelectSurface = (
		surfaces: ToothSurface[],
		operation: SurfaceOperation,
	) => {
		decays?.setSurfaces(decayIndex, surfaces, operation);
	};

	return {
		showedSurfaces,
		selectedSurfaces,
		handleSelectSurface,
		decayIndex,
	} as SurfaceHandler;
}
